import React, { useState, useRef, useEffect } from 'react';
import './pre fab.css';

function PreFabWarehouseBuilding() {
  const img = [
    '/pre fab 1.png',
    '/pre fab 2.png',
    '/pre fab 3.png',
    '/pre fab 4.png',
  ];

  const [activeImage, setActiveImage] = useState(0);






  


   
    

  return (
    <div className="aluminium-window">

      {/* Hero Section */}
      <section className="aluminium-hero">
        <div className="hero-content">

          <div className="hero-text">
            <h1 className="hero-title">Pre-Fabricated Solutions</h1>
            <p className="hero-subtitle">
              Durable, cost-effective, and fast-to-install pre-fabricated warehouse
              solutions designed for industrial and commercial use.
            </p>
          </div>

          <div className="hero-image">
            <img
              src={img[activeImage]}
              alt="Pre-fab Warehouse Building"
              className="hero-main-image"
            />

            <div className="image-thumbnails">
              {img.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Pre-fab view ${index + 1}`}
                  className={`thumbnail ${activeImage === index ? 'active' : ''}`}
                  onClick={() => setActiveImage(index)}
                />
              ))}
            </div>
          </div>

        </div>
      </section>







{/* Features */}
<section className="features-section">
  <div className="section-header">
    <h2>Why Choose Pre-Fab Warehouses?</h2>
    <p>Smart industrial construction with long-term performance</p>
  </div>

  <div className="features-grid">
    <div className="feature-card">
      <h3>Fast Construction</h3>
      <p>Significantly reduces construction time compared to conventional buildings.</p>
    </div>

    <div className="feature-card">
      <h3>Cost Efficient</h3>
      <p>Optimized material usage and faster installation lower overall costs.</p>
    </div>

    <div className="feature-card">
      <h3>High Strength</h3>
      <p>Designed to withstand heavy loads and harsh industrial conditions.</p>
    </div>

    <div className="feature-card">
      <h3>Customizable Design</h3>
      <p>Flexible layouts to suit warehouses, factories, and storage facilities.</p>
    </div>

    <div className="feature-card">
      <h3>Low Maintenance</h3>
      <p>Corrosion-resistant materials reduce maintenance costs over the building’s lifespan.</p>
    </div>

    <div className="feature-card">
      <h3>Scalable & Expandable</h3>
      <p>Easy to extend or modify the structure as your business grows.</p>
    </div>
  </div>
</section>




      {/* CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Plan Your Warehouse Today</h2>
          <p>Contact us for customized pre-fabricated building solutions</p>

          <a
            href="/contactus"
            className="btn-outline"
            style={{ textDecoration: 'none' }}
          >
            Contact Us
          </a>



        </div>
      </section>

    </div>
  );
}

export default PreFabWarehouseBuilding;
